export function replaceHtml(str: string): string {
  return str.replace(/<img.*?>/g, '(사진)').replace(/&nbsp;/g, ' ');
}
